import React, { useState } from "react";
import RibbonTag from "../RibbonTag";
import PropTypes from "prop-types";

import { useAuth } from "../../../hoc/AuthContext";

import { defaultTextColor } from "../../../Utils/CommonFunctions";

export default function AccessMembershipExperienceCardDesign({ whatsDesign, mobileViewCardDesign, isMobile, item, image, similarCard }) {
  const [showText, setShowText] = useState(false);

  const handleMouseEnter = () => {
    setShowText(true);
  };

  const handleMouseLeave = () => {
    setShowText(false);
  };

  const { integratorTheme } = useAuth();

  const formatStoreType = (text) => {
    const isOnline = text?.includes("ONLINE");
    const isOffline = text?.includes("OFFLINE");
    if (isOnline && isOffline) return "Online/Offline";
    if (isOnline) return "Online";
    if (isOffline) return "Offline";
    return "";
  };

  const dimensions = () => {
    if (whatsDesign) {
      return isMobile ? "w-[87px] h-[60px]" : "w-[196px] h-[126px]";
    } else if (mobileViewCardDesign) {
      return isMobile ? "sm:w-[180px] mobileViewAccessDesign sm:h-[180px]" : "w-[196px] h-[196px]";
    } else if (similarCard && isMobile) {
      return "w-[155px] h-[145px]";
    }
    return "w-[196px] h-[196px]";
  };

  return (
    <div
      className={`${dimensions()} bg-contain flex justify-center items-center rounded-[10px] drop-shadow-md bg-no-repeat bg-center`}
      style={{ backgroundImage: `url('${image}')`, backgroundColor: `#${item?.brand?.hex_code}`, }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {!image && (
        <div className={`text-xl text-center ${item?.brand?.hex_code === "FFFFFF" ? "text-black" : "text-white"}`}>
          {item?.brand?.name}
        </div>
      )}
      {isMobile && !whatsDesign ? (
        <div style={{ color: defaultTextColor(integratorTheme) }} className="absolute top-1 left-2 text-[10px]">{formatStoreType(item?.redemption_channel)}</div>
      ) : (
        <>
          {!whatsDesign && <RibbonTag showText={showText} channels={item?.redemption_channel} />}
        </>
      )}
    </div>
  );
};

AccessMembershipExperienceCardDesign.propTypes = {
  whatsDesign: PropTypes.bool,
  mobileViewCardDesign: PropTypes.bool,
  isMobile: PropTypes.bool,
  item: PropTypes.shape({
    brand: PropTypes.shape({
      hex_code: PropTypes.string,
      name: PropTypes.string,
    }),
    redemption_channel: PropTypes.arrayOf(PropTypes.string),
  }),
  image: PropTypes.string,
};